import React from 'react';
import moment from 'moment';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import Table from '../../../../shared/table';

const tableColumns = ['Integration Name', 'Created At', 'Actions']

interface IIntegrationsTable {
    rows: any;
    paginationData?: IPage;
    rowsLoading: boolean;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
    onSeeDetails: (data: any) => void;
    onDeleteIntegration: (id: string) => void;
    onEditIntegration: (id: string, data: any) => void;
}

const IntegrationsTable = ({
    rows,
    paginationData,
    rowsLoading,
    setPaginationState,
    onSeeDetails,
    onDeleteIntegration,
    onEditIntegration
}: IIntegrationsTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}
        >
            {rowsLoading ?
                <>
                    {[...Array(4)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                                    return (
                                        <td key={j} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                <td className='px-6 py-4'>{row?.name}</td>
                                <td className='px-6 py-4'>{moment(row?.createdAt || '').format('DD/MM/YYYY, mm:hh')}</td>

                                <td className='px-4 py-4'>
                                    <div className='flex flex-row justify-around'>
                                        <div data-qa={'view-details'} onClick={() => onSeeDetails(row)}>
                                            <img title={'View Details'} alt='item details' src={'/assets/table-actions/visibility.svg'} className={'h-[14px] object-contain cursor-pointer mr-3'} />
                                        </div>
                                        <div data-qa={'edit-details'} onClick={() => onEditIntegration(row?._id || '', row)}>
                                            <img title={'Edit Details'} alt='edit details' src={'/assets/table-actions/pen.svg'} className={'h-[14px] object-contain cursor-pointer mr-3'} />
                                        </div>
                                        <div data-qa={'delete'} onClick={() => row?._id && onDeleteIntegration(row?._id)}>
                                            <img title={'Delete'} alt='delete item' src={'/assets/table-actions/delete-close.svg'} className={'h-[14px] object-contain cursor-pointer'} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default IntegrationsTable;